// extracted by mini-css-extract-plugin
export default {"button_delete":"ButtonDelete_button_delete__q1cBF"};